import { timestamp_to_date } from '@/utils/time';
import { z } from 'zod'

export const CaseTypeSchema = z.object({
  id: z.number(),
  name: z.string()
});

export const PersonSchema = z.object({
  id: z.string(),
  name: z.string()
});

export const LocationSchema = z.object({
  id: z.number(),
  name: z.string(),
  ville_id: z.number().nullish(),
  ville_name: z.string().nullish(),
});

export const CaseRelationTypeEnum = z.enum(['appeal', 'cassation', 'related', 'continuation', 'opposition']);
export type CaseRelationType = z.infer<typeof CaseRelationTypeEnum>;

export const ParentCaseSchema = z.object({
  id: z.number(),
  name: z.string(),
  number: z.number().nullable().optional(),
  year: z.number().nullable().optional(),
  created_at: z.string().optional()
}).nullable();

export const ChildCaseSchema = z.object({
  id: z.number(),
  name: z.string(),
  number: z.number().nullable().optional(),
  year: z.number().nullable().optional(),
  relation_type: CaseRelationTypeEnum.nullable().optional(),
  created_at: z.string().optional()
});

// Fee type enum for the case
export const FeeTypeEnum = z.enum(['fixed', 'percentage']);
export type FeeType = z.infer<typeof FeeTypeEnum>;

// Status enum for the case
export const CaseStatusEnum = z.enum(['active', 'audience', 'delibere', 'suspended', 'closed', 'archived', 'incomplete']);
export type CaseStatus = z.infer<typeof CaseStatusEnum>;

export const AdversarySchema = z.object({
  id: z.string(),
  name: z.string(),
}).passthrough();

export const caseSchema = z.object({
  id: z.number(),
  name: z.string(),
  client: PersonSchema,
  added_by: PersonSchema,
  type: CaseTypeSchema.nullable(),
  assigned_to: PersonSchema.nullable(),
  year: z.number().nullable(),
  number: z.number().nullable(),
  code: z.number().nullable(),
  created_at: z.number().transform(timestamp_to_date),
  updated_at: z.number().transform(timestamp_to_date),
  location: LocationSchema.nullable(),
  archived_at: z.number().transform(timestamp_to_date).nullable(),
  status: CaseStatusEnum.nullable().optional(), // Added status field
  service_fee: z.string().nullable(),
  fee_type: FeeTypeEnum.nullable().optional(),
  fee_reference_amount: z.string().nullable().optional(),
  calculated_fee: z.string().nullable().optional(),
  visibility: z.enum(['public', 'partial', 'private']),
  is_favorite: z.boolean().optional().default(false),
  parent_case: ParentCaseSchema.optional(),
  child_cases: z.array(ChildCaseSchema).optional(),
  relation_type: CaseRelationTypeEnum.nullable().optional(),
  adversaries_count: z.number().optional(),
  adversaries: z.array(AdversarySchema).optional(),
})
export type Case = z.infer<typeof caseSchema>
export type Person = z.infer<typeof PersonSchema>
export type Location = z.infer<typeof LocationSchema>
export type CaseType = z.infer<typeof CaseTypeSchema>

export const caseListSchema = z.array(caseSchema)
